// extracted by mini-css-extract-plugin
module.exports = {"commsTab":"CommsWrapper_commsTab__1NoCy"};